export const LABELS = {
  default: "Select a trade",
  ai: "Describe your trade",
} as const;

export const PLACEHOLDERS = {
  default: "e.g. plumber",
  ai: "e.g. I bake cakes",
} as const;

export const TRADES_ENDPOINTS = {
  production: "https://quote.simplybusiness.com/trade_search",
  staging: "https://quote-staging.simplybusiness.com/trade_search",
} as const;

export const DEFAULT_TRADES_ENDPOINT =
  process.env.NODE_ENV === "production"
    ? TRADES_ENDPOINTS.production
    : TRADES_ENDPOINTS.staging;
